import { useTranslation } from "react-i18next";

const VALUE_TO_POSITION = {
  lowest: 1,
  low: 2,
  medium: 3,
  high: 4,
  highest: 5,
};

const POSITION_TO_VALUE = {
  1: "lowest",
  2: "low",
  3: "medium",
  4: "high",
  5: "highest",
};

export const SensitivitySlider = ({
  signalKey,
  label,
  value,
  onChange,
  disabled,
}) => {
  const { t } = useTranslation();
  const position = VALUE_TO_POSITION[value] || 3;
  const percentage = ((position - 1) / 4) * 100;

  const handleChange = (e) => {
    const newPosition = parseInt(e.target.value, 10);
    const newValue = POSITION_TO_VALUE[newPosition];
    onChange(signalKey, newValue);
  };

  const getValueLabel = (val) => {
    return t(`pages.settings.actionsSettings.sensitivity.values.${val}`);
  };

  return (
    <div className="flex items-center py-1.5">
      <span className="w-52 text-sm text-gray-600">{label}</span>
      <input
        type="range"
        min="1"
        max="5"
        step="1"
        value={position}
        onChange={handleChange}
        disabled={disabled}
        className="sensitivity-slider mx-3 h-1.5 w-32 cursor-pointer appearance-none rounded-full bg-transparent disabled:cursor-not-allowed disabled:opacity-50"
        aria-label={label}
        style={{
          background: `linear-gradient(to right, #3b82f6 0%, #3b82f6 ${percentage}%, #e5e7eb ${percentage}%, #e5e7eb 100%)`,
        }}
      />
      <span className="w-16 text-sm text-gray-500">{getValueLabel(value)}</span>
      <style>{`
        .sensitivity-slider::-webkit-slider-thumb {
          -webkit-appearance: none;
          appearance: none;
          width: 18px;
          height: 18px;
          border-radius: 50%;
          background: white;
          border: 2px solid #d1d5db;
          cursor: pointer;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
        }
        .sensitivity-slider::-moz-range-thumb {
          width: 18px;
          height: 18px;
          border-radius: 50%;
          background: white;
          border: 2px solid #d1d5db;
          cursor: pointer;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
        }
        .sensitivity-slider::-webkit-slider-thumb:hover {
          border-color: #9ca3af;
        }
        .sensitivity-slider::-moz-range-thumb:hover {
          border-color: #9ca3af;
        }
        .sensitivity-slider:disabled::-webkit-slider-thumb {
          cursor: not-allowed;
        }
        .sensitivity-slider:disabled::-moz-range-thumb {
          cursor: not-allowed;
        }
      `}</style>
    </div>
  );
};
